import { XMark } from "@medusajs/icons"
import { useEffect } from "react"
import { Link } from "react-router-dom"
import { t } from "../lib/i18n"
import { MoreContent } from "../routes/more"

/**
 * «More» on a phone (owners, 16 Oct 2026): a sheet from the right over most of the page, favourites
 * first and then every section; the page stays visible, blurred, beside it, and a tap on it closes
 * the sheet and returns to it exactly as it was. Choosing a section closes it too (the shell closes it
 * on every change of page).
 */
export function MoreDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return
    const key = (event: KeyboardEvent) => event.key === "Escape" && onClose()
    window.addEventListener("keydown", key)
    const overflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      window.removeEventListener("keydown", key)
      document.body.style.overflow = overflow
    }
  }, [open, onClose])
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <button type="button" aria-label={t("Close")} onClick={onClose} className="hc-drawer-backdrop absolute inset-0 bg-black/25 backdrop-blur-[3px]" />
      <aside role="dialog" aria-modal="true" aria-label={t("More")} className="hc-drawer bg-ui-bg-subtle pt-safe pb-safe absolute inset-y-0 right-0 flex w-[82%] max-w-[420px] flex-col shadow-2xl">
        <div className="flex items-center justify-between gap-x-3 px-4 pb-2 pt-4">
          <span className="hc-title text-[26px] leading-none">{t("More")}</span>
          <div className="flex items-center gap-x-1">
            <Link to="/settings#tabs" onClick={onClose} className="txt-compact-small-plus text-ui-fg-interactive rounded px-2 py-1.5">
              {t("Edit the bar")}
            </Link>
            <button type="button" onClick={onClose} aria-label={t("Close")} className="text-ui-fg-muted hover:text-ui-fg-base rounded p-2">
              <XMark />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto overscroll-contain px-4 pb-6 pt-1">
          <MoreContent />
        </div>
      </aside>
    </div>
  )
}
